import React, { Component } from 'react';
import Header from '../../layout/Partials/Header';
import { editObject, getObject } from '../../../redux/actions/objectsAction';
import { getPage } from '../../../redux/actions/pagesActions';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Theme } from '../../../utils/Theme';
import AdminLayout from '../../layout/AdminLayout';
import { Button, Divider, Grid, Paper, Typography } from '@material-ui/core';
import TextFieldGroup from '../../common/TextFieldGroup';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import clsx from 'clsx';
const styles = Theme();

class EditHtmlObject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: null,
            row: null,
            sortOrder: null,
            object: null,
            page: null,
            loading: true,
            xs: null,
            sm: null,
            md: null,
            elevation: null,
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleModelChange = this.handleModelChange.bind(this);
    }

    componentDidMount() {
        const page = this.props.match.params.page;
        const object = this.props.match.params.object;

        //GET PAGE CONTENT
        this.props.getPage(page);
        this.props.getObject(page, object);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { pages, errors, objects } = nextProps;
        let { page, object, loading, model, xs, sm, md, elevation } = prevState;

        if (
            !pages.loading &&
            page !== pages.page &&
            !objects.loading &&
            objects.object
        ) {
            object = objects.object;
            xs = object.size.xs;
            sm = object.size.sm;
            md = object.size.md;
            elevation = object.elevation;

            model = object.editorState;
            page = pages.page;
            loading = false;
        }
        return { errors, page, object, model, loading, xs, sm, md, elevation };
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { page, object, xs, sm, md, elevation } = this.state;
        const editorState = this.state.model;

        const object_data = {
            sortOrder: object.sortOrder,
            row: object.row,
            page: page._id,
            editorState,
            qsId: 'draftObject',
            type: 'draftObject',
            xs,
            sm,
            md,
            elevation,
        };

        this.props.editObject(
            page._id,
            object._id,
            object_data,
            this.props.history
        );
    };

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleModelChange(model) {
        this.setState({
            model: model,
        });
    }

    render() {
        const { page, errors } = this.state;
        const { classes } = this.props;
        return (
            <AdminLayout>
                <div className="o-page">
                    <Header hideSearchBar title={'Edit HTML Object'} />
                    <Paper className={clsx('u-m-xsmall full_height')}>
                        <div className="u-p-small">
                            <div className={'u-m-zero'}>
                                <div className="o-line ">
                                    <div>
                                        <h4 className={`c-card__title `}>
                                            {page?.title} | Edit Object
                                        </h4>
                                    </div>
                                    <div>
                                        <Button
                                            className={`${classes.buttonSecondary}`}
                                            onClick={(e) =>
                                                this.props.history.goBack()
                                            }
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>

                                <div className="u-m-small">
                                    <div className="row u-justify-center">
                                        <div className="col-md-12 col-xl-12 u-m-auto u-mb-medium">
                                            <div>
                                                <form onSubmit={this.onSubmit}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={12}>
                                                            <ReactQuill
                                                                modules={{
                                                                    toolbar: [
                                                                        [
                                                                            {
                                                                                header:
                                                                                    '1',
                                                                            },
                                                                            {
                                                                                header:
                                                                                    '2',
                                                                            },
                                                                        ],
                                                                        [
                                                                            {
                                                                                size: [],
                                                                            },
                                                                        ],
                                                                        [
                                                                            'bold',
                                                                            'italic',
                                                                            'underline',
                                                                        ],
                                                                        [
                                                                            {
                                                                                list:
                                                                                    'ordered',
                                                                            },
                                                                            {
                                                                                list:
                                                                                    'bullet',
                                                                            },
                                                                            {
                                                                                indent:
                                                                                    '-1',
                                                                            },
                                                                            {
                                                                                indent:
                                                                                    '+1',
                                                                            },
                                                                        ],
                                                                        [
                                                                            {
                                                                                color: [
                                                                                    '#ffffff',
                                                                                    '#4f3486',
                                                                                    '#93d50a',
                                                                                    '#7f3586',
                                                                                    '#54a684',
                                                                                    '#cb7537',
                                                                                    '#282F37',
                                                                                    '#000000',
                                                                                    '#878c91',
                                                                                    '#dde1eb',
                                                                                ],
                                                                            },
                                                                        ],
                                                                    ],
                                                                    clipboard: {
                                                                        // toggle to add extra line breaks when pasting HTML:
                                                                        matchVisual: false,
                                                                    },
                                                                }}
                                                                theme={'snow'}
                                                                editorStyle={{
                                                                    minHeight: 400,
                                                                }}
                                                                formatText={{
                                                                    color:
                                                                        '#ffffff',
                                                                }}
                                                                format={{
                                                                    color:
                                                                        '#ffffff',
                                                                }}
                                                                className={' '}
                                                                value={
                                                                    this.state
                                                                        .model ||
                                                                    ''
                                                                }
                                                                onChange={(
                                                                    html
                                                                ) =>
                                                                    this.setState(
                                                                        {
                                                                            model: html,
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            style={{
                                                                paddingTop: 20,
                                                            }}
                                                        >
                                                            <Divider />
                                                            <Typography
                                                                variant={
                                                                    'subtitle1'
                                                                }
                                                            >
                                                                Appearance
                                                            </Typography>
                                                            <Typography
                                                                vatiant={
                                                                    'caption'
                                                                }
                                                            >
                                                                Each grid row is
                                                                split into 12
                                                                columns
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <TextFieldGroup
                                                                label="Mobile Columns"
                                                                type="text"
                                                                onChange={
                                                                    this
                                                                        .onChange
                                                                }
                                                                value={
                                                                    this.state
                                                                        .xs
                                                                }
                                                                name="xs"
                                                                error={
                                                                    errors.xs
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <TextFieldGroup
                                                                label="Tablet Columns"
                                                                type="text"
                                                                onChange={
                                                                    this
                                                                        .onChange
                                                                }
                                                                value={
                                                                    this.state
                                                                        .sm
                                                                }
                                                                name="sm"
                                                                error={
                                                                    errors.sm
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <TextFieldGroup
                                                                label="Desktop Columns"
                                                                type="text"
                                                                onChange={
                                                                    this
                                                                        .onChange
                                                                }
                                                                value={
                                                                    this.state
                                                                        .md
                                                                }
                                                                name="md"
                                                                error={
                                                                    errors.md
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <TextFieldGroup
                                                                label="Elevation"
                                                                type="text"
                                                                onChange={
                                                                    this
                                                                        .onChange
                                                                }
                                                                value={
                                                                    this.state
                                                                        .elevation
                                                                }
                                                                name="elevation"
                                                                error={
                                                                    errors.elevation
                                                                }
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <button
                                                                type={'submit'}
                                                                className={`c-btn c-btn-sm c-btn-primary ${classes.buttonPrimary}`}
                                                            >
                                                                Save Object
                                                            </button>
                                                        </Grid>
                                                    </Grid>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </div>
            </AdminLayout>
        );
    }
}

EditHtmlObject.propTypes = {
    auth: PropTypes.object.isRequired,
    pages: PropTypes.object.isRequired,
    editObject: PropTypes.func.isRequired,
    getObject: PropTypes.func.isRequired,
    getPage: PropTypes.func,
    objects: PropTypes.object,
    errors: PropTypes.object.isRequired,
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    pages: state.pages,
    errors: state.errors,
    objects: state.objects,
});

export default connect(mapStateToProps, {
    editObject,
    getObject,
    getPage,
})(withRouter(withStyles(styles)(EditHtmlObject)));
